export const scrollActivityLogToBottom = () => {
  setTimeout(() => {
    try {
      var div = document.getElementById('activity-log-inner');
      if (!div) return;
      div.scrollTop = div.scrollHeight;
    } catch (e) {}
  }, 500);
};
